<c11n-modal-dialog #divCapGainsModal modalId="divCapGains" [headingText]="content.modalContent.divcapgains.header">
  <div c11n-modal-dialog-body>
    @for (paragraph of content.modalContent.divcapgains.paragraphs; track paragraph) {
      <p class="c11n-text-md"
      [innerHTML]="paragraph"></p>
    }

    <div class="c11n-modal-dialog__content__buttons">
      <c11n-button labelText="Close" (clickEvent)='closeDivCapModal()' data-btn="dialog-content-button"></c11n-button>
    </div>
  </div>
</c11n-modal-dialog>

<c11n-modal-dialog #settlementFundModal modalId="settlementFund"
  [headingText]="content.modalContent.settlementFund.header">
  <div c11n-modal-dialog-body>
    @for (paragraph of content.modalContent.settlementFund.paragraphs; track paragraph) {
      <p class="c11n-text-md"
      [innerHTML]="paragraph"></p>
    }

    <div class="c11n-modal-dialog__content__buttons">
      <c11n-button labelText="Close" (clickEvent)='closeSettlementModal()' data-btn="dialog-content-button">
      </c11n-button>
    </div>
  </div>
</c11n-modal-dialog>

<c11n-modal-dialog #beneficiariesModal modalId="beneficiaries"
  [headingText]="content.modalContent.beneficiaries.header">
  <div c11n-modal-dialog-body>
    @for (paragraph of content.modalContent.beneficiaries.paragraphs; track paragraph) {
      <p class="c11n-text-md"
      [innerHTML]="paragraph"></p>
    }

    <div class="c11n-modal-dialog__content__buttons">
      <c11n-button labelText="Close" (clickEvent)='closeBeneficiariesModal()' data-btn="dialog-content-button">
      </c11n-button>
    </div>
  </div>
</c11n-modal-dialog>
